/* es5-ext/number/to-pos-integer */ function _(require, module, exports) {
    var toInteger = require(336) /* ./to-integer */, max = Math.max;
    module.exports = function (value) {
        return max(0, toInteger(value));
    };
}
